import React from 'react';
import { get } from 'lodash';
import { Text, If, Icon } from '../../../../../../../components/common';
import { Switch } from 'antd';
import { weightMessages, getWeightValidationVisuals } from './WeightValidationShared';

const WeightValidationCompact = ({ weightError, semaphore, callback }) => {
    const { color, semaphoreStyles } = getWeightValidationVisuals(weightError, semaphore);

    return (
        <div style={{
            borderRadius: "8px",
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: weightError === 'true' ? `rgba(247, 212, 216, 0.5)` : `rgba(221, 236, 178, 0.5)`,
            margin: '0 10px 6px 10px',
            padding: "4px 12px",
            alignContent: 'center'
        }}>
            <span>
                <Text text={'Validación de peso :'} size={14} color='#323A44' strong />
                <Icon name='ic-cart' size={14} color={color} style={{ margin: '0px 2px' }} />
                <Text text={weightError === 'true' ? 'Rechazada' : 'Aprobada'} color={color} size={14} strong />
            </span>
            <span>
                <Text size={14} text={'Desviación:'} strong />
                <Text text={semaphore ? semaphoreStyles.text : '-'} color={semaphore ? semaphoreStyles.color : color} size={14} strong />
            </span>
            <If
                condition={get(weightMessages, `${weightError}.switchable`)}
                then={
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                        <Switch
                            checkedChildren='Aprobado'
                            unCheckedChildren='Rechazado'
                            onChange={callback}
                        />
                    </div>
                }
            />
        </div>
    );
};

export default React.memo(WeightValidationCompact);
